class Opt {
    key: number;
    name: string;
    desc?: string;
    private active = false;
    img?: string;
    private disabled = false;

    constructor(key: number, name: string, desc?: string, img?: string) {
        this.key = key;
        this.name = name;
        this.desc = desc;
        this.img = img;
    }

    setActive(act: boolean) {
        this.active = act;
    }

    getActive(): boolean {
        return this.active;
    }

    get disable(): boolean {
        return this.disabled;
    }

    set disable(dis: boolean) {
        this.disabled = dis;
    }
}

export default Opt;
